import { ICON_NAMES } from '@/config/config';

import { ApplicationType } from '../../../../../config/types';

export const getCardHeaderParamsByApplicationType = (applicationType: ApplicationType) => {
  switch (applicationType) {
    case ApplicationType.CONSUMER_LOAN:
      return {
        title: 'CONSUMER_LOAN',
        surtitle: 'APPLICATION',
        iconName: ICON_NAMES.CONSUMER_LOAN,
      };
    case ApplicationType.ORDER:
      return {
        title: 'ORDER',
        surtitle: 'APPLICATION',
        iconName: ICON_NAMES.PAY_BY_LINK,
      };
    case ApplicationType.AUTO:
      return {
        title: 'AUTO',
        surtitle: 'APPLICATION',
        iconName: ICON_NAMES.AUTO,
      };
    case ApplicationType.CREDIT_LINE:
      return {
        title: 'CREDIT_LINE',
        surtitle: 'APPLICATION',
        iconName: ICON_NAMES.CREDIT_LINE,
      };
    case ApplicationType.CARD:
      return {
        title: 'CARD',
        surtitle: 'APPLICATION',
        iconName: ICON_NAMES.CARD,
      };
    case ApplicationType.CHECKOUT_SESSION:
      return {
        title: 'CHECKOUT_SESSION',
        surtitle: 'CART',
        iconName: ICON_NAMES.CHECKOUT_SESSION,
      };
    default:
      return {
        title: 'CONSUMER_LOAN',
        surtitle: 'APPLICATION',
        iconName: ICON_NAMES.PAY_BY_LINK,
      };
  }
};
